module.exports = __webpack_public_path__ + "img/email.d6520dd2.svg";